import React, { Component } from 'react';
import { colors } from '../../../constants';
import './ColorList.css';

class ColorList extends Component {

    state = {
        color: colors
    };

    render() {
        let count = 0 ;
        let colorCount = 0
        let list = this.props.circleData.map(circleItem => {
            if (this.props.groupId === circleItem.groupId) {
                let color = !circleItem.competitorId
                if(color){
                    count += 1
                    colorCount = 0
                }else{
                    colorCount+=1
                }
                return (
                    <li>
                        <style type="text/css">
                                @media print{`{
                                    .a${this.state.color[count].color[colorCount]}{
                                        background: #${this.state.color[count].color[colorCount]} !important
                                    }
                                }`}
                            </style>
                        <div style={{ backgroundColor: '#' + this.state.color[count].color[colorCount], WebkitColorAdjust: '#' + this.state.color[count].color[colorCount]}} className={`a${this.state.color[count].color[colorCount]}`}>
                            
                        </div>
                        <p>{circleItem.name}</p>
                    </li>
                )
            }

        });

        return (
            <ul className='color-list'>
                {list}
            </ul>

        );
    }
}

//export default (<Test />, document.getElementById('root'));
export default (ColorList);



// WEBPACK FOOTER //
// ./src/components/Prioritizer/Result/TabContent/ColorList/ColorList.jsx